import React, { useContext } from 'react';
import { Link } from 'react-router-dom';
import BlockingSpinnerOverlay from 'components/BlockingSpinnerOverlay';
import HStreamIDField from 'components/fields/HStreamIDField';
import PropTypes from 'prop-types';
import { Alert, Button, Form, FormGroup } from 'reactstrap';
import { reduxForm } from 'redux-form';
import locationShape from 'shapes/locationShape';
import LabelwithLoginInformationTooltip from '../../components/Utilities/LabelWithInformationTooltip';
import HpaStoreContext from '../../contexts/HpaStoreContext';

const SignInForm = (props) => {
    const { handleSubmit, onSubmit, isLoading, location } = props;
    const context = useContext(HpaStoreContext);

    const toResetPassword = {
        pathname: '/forgotPassword',
        search: location?.search || '',
    };

    const tooltipContent = [
        'If you verified by phone, login with your phone number.',
        'If you verified by email, login with your email.',
    ];
    const loginInstructionText =
        context &&
        Array.isArray(context.customBranding) &&
        context.customBranding.find(
            (detail) =>
                detail.name === 'loginInstructionText' &&
                (detail.text === 'customBranding' || detail.text === null || detail.text === undefined)
        );

    return (
        <Form
            className="position-relative"
            aria-busy={isLoading}
            onSubmit={handleSubmit(onSubmit)}
        >
            <BlockingSpinnerOverlay show={isLoading} ariaLabel="Loading..." />
            <HStreamIDField
                name="username"
                id="hStream_login_id"
                label={
                    <LabelwithLoginInformationTooltip
                        labelText="Email or Mobile Number"
                        tooltipId="sign_in_tt"
                        tooltipContent={tooltipContent}
                    />
                }
            />
            <div
                id="forgot-email-password-link"
                className="text-muted text-sm"
                style={{ margin: '-.5em 0 1rem' }}
            >
                <a
                    href="#"
                    id="forgot-email-link"
                    role="button"
                    className="text-muted text-sm"
                    tabIndex={isLoading ? -1 : 0}
                    aria-disabled={isLoading || undefined}
                    onClick={(e) => {
                        e.preventDefault();
                        if (isLoading) return;
                    }}
                >
                    Forgot Email
                </a>
                {' '}
                <Link
                    to={toResetPassword}
                    id="forgot-password-link"
                    className="text-muted text-sm"
                    tabIndex={isLoading ? -1 : 0}
                    aria-disabled={isLoading || undefined}
                    onClick={(e) => {
                        if (isLoading) e.preventDefault();
                    }}
                >
                    or Password?
                </Link>
            </div>
            <FormGroup>
                <Button
                    className="btn"
                    block
                    color="primary"
                    disabled={isLoading}
                    type="submit"
                >
                    Continue to Password
                </Button>
            </FormGroup>
            {loginInstructionText && loginInstructionText.value && loginInstructionText.value.trim() !== '' && (
                <div>
                    <Alert color="info">{loginInstructionText.value}</Alert>
                </div>
            )}
        </Form>
    );
};

SignInForm.propTypes = {
    handleSubmit: PropTypes.func.isRequired,
    onSubmit: PropTypes.func.isRequired,
    isLoading: PropTypes.bool,
    location: locationShape.isRequired,
    rememberMeValues: PropTypes.shape({
        display: PropTypes.bool,
        value: PropTypes.bool,
        disable: PropTypes.bool,
    }).isRequired,
};

SignInForm.defaultProps = {
    isLoading: false,
};

const ConnectedSignInForm = reduxForm({
    form: 'sign-in',
})(SignInForm);

export default ConnectedSignInForm;
export { SignInForm as PureSignInForm };
